import { OPEN_FILE_MANAGER_MODAL, CLOSE_FILE_MANAGER_MODAL, CLOSE_FILE_MANAGER_MODAL_COMPLETE, INSERT_IMAGE, INSERT_FILE, CLOSE_EDIT_VIDEO_MODAL, SAVE_EDIT_VIDEO_MODAL } from './ActionTypes';
export function openFileManager({
  type,
  modalId,
  initialPanel
}) {
  return {
    type: OPEN_FILE_MANAGER_MODAL,
    fileType: type,
    initialPanel,
    modalId
  };
}
export function closeFileManagerModal() {
  return {
    type: CLOSE_FILE_MANAGER_MODAL
  };
}
export function closeFileManagerModalComplete(modalId) {
  return {
    type: CLOSE_FILE_MANAGER_MODAL_COMPLETE,
    modalId
  };
}
export function insertImage(modalId, file) {
  return {
    type: INSERT_IMAGE,
    file,
    modalId
  };
}
export function insertFile(modalId, file) {
  return {
    type: INSERT_FILE,
    file,
    modalId
  };
}
export function closeEditVideoModal() {
  return {
    type: CLOSE_EDIT_VIDEO_MODAL
  };
}
export function saveModalComplete(video) {
  return {
    type: SAVE_EDIT_VIDEO_MODAL,
    video
  };
}